import React, { useState } from 'react';

import Select from 'react-select'

const AirportSearch = (props) => {

  const [selectedOption, setSelectedOption] = useState("");
  const travelagents = [{ 'value': 'Surgery Now', "label": "Surgery Now" }, { 'value': 'Healthcare Abroad', 'label': 'Healthcare Abroad' }]

  const airports =
    [
      {
        "value": "DUB",
        "label": "Dublin Airport"
      },
      {
        "value": "ORK",
        "label": "Cork Airport"
      },
      {
        "value": "BFS",
        "label": "Belfast International Airport"
      },
      {
        "value": "EDI",
        "label": "Edinburgh Airport"
      },
      {
        "value": "BRS",
        "label": "Bristol Airport"
      },
      {
        "value": "ALC",
        "label": "Alicante Airport"
      },
      {
        "value": "RMU",
        "label": "Corvera Airport Murcia (RMU)"
      },
      {
        "value": "GLA",
        "label": "Glasgow Airport"
      },
      {
        "value": "SNN",
        "label": "Shannon Airport"
      },
      {
        "value": "SOU",
        "label": "Southampton Airport"
      },
      {
        "value": "JED",
        "label": "King Abdulaziz International Airport "
      },
      {
        "value": "RUH",
        "label": "King Khalid International Airport"
      },
      {
        "value": "CFN",
        "label": "Donegal Airport"
      },
      {
        "value": "MAN",
        "label": "Manchester Airport"
      },
      {
        "value": "BOS",
        "label": "Boston Airport"
      },
      {
        "value": "SYD",
        "label": "Sydney Airport"
      },
      {
        "value": "PER",
        "label": "Perth Airport"
      },
      {
        "value": "LHR",
        "label": "London Heathrow"
      },
      {
        "value": "BHX",
        "label": "Birmingham Airport"
      },
      {
        "value": "JER",
        "label": "Jersey Airport"
      },
      {
        "value": "BHD",
        "label": "Belfast City Airport"
      },
      {
        "value": "INV",
        "label": "Inverness Airport"
      },
      {
        "value": "AUH",
        "label": "Zayed International Airport"
      },
      {
        "value": "DOH",
        "label": "Hamad International Airport"
      },
      {
        "value": "PUJ",
        "label": "Punta Cana International Airport"
      },
      {
        "value": "MLA",
        "label": "Malta International Airport"
      }
    ];

  const airlines =
    [
      {
        value: "ALL",
        label: "Master"
      },
      {
        "value": "FR",
        "label": "Ryanair"
      },
      {
        "value": "EI",
        "label": "Aer Lingus"
      },
      {
        "value": "U2",
        "label": "EasyJet"
      },
      {
        "value": "AA",
        "label": "American Airlines"
      },
      {
        "value": "TK",
        "label": "Turkish Airlines"
      },
      {
        "value": "UA",
        "label": "United Airlines"
      },
      {
        "value": "EK",
        "label": "Emirates"
      },
      {
        "value": "QR",
        "label": "Qatar Airways"
      },
      {
        "value": "DL",
        "label": "Delta"
      },
      {
        "value": "AC",
        "label": "Air Canada"
      },
      {
        "value": "BA",
        "label": "British Airways"
      },
      {
        "value": "TOM",
        "label": "TUI Airways"
      },
      {
        "value": "KL",
        "label": "KLM"
      },
      {
        "value": "LY",
        "label": "EL AL Airlines"
      },
      {
        "value": "B6",
        "label": "JetBlue"
      },
      { value: "AP", label: "Alba Star" },
      { value: "TS", label: "Air Transat" },
      { value: "TP", label: "Air Portugal" },
      { value: "WS", label: "WestJet" },
      { value: "ENT", label: "Enter Airlines" },
      { value: "CM", label: "Copa Airlines" },
      { value: "NK", label: "Spirit Airlines" },
      { value: "TX", label: "Air Caraïbes" },
      { value: "F9", label: "Frontier Airlines" },
      { value: "H2", label: "Sky Peru" },
      { value: "6O", label: "Orbest" },
      { value: "E9", label: "Evelop airline" },
      { value: "G4", label: "Allegiant Air" },
      { value: "SY", label: "Sun Country Airlines" },
      { value: "G3", label: "GOL Linhas Aéreas" },//gollinhasaereas
      { value: "DM", label: "Arajet Airlines" },
      { value: "5R", label: "Rutaca Airlines" },

    ];
  const handleChange = (selection) => {
    props.setSelection(selection.value);
    props.setAirport(selection.label);
  };

  // Get the current value based on props
  const currentValue = props.type === 'airport'
    ? airports.find(opt => opt.value === props.value) :
    props.type === 'airline'
      ? airlines.find(opt => opt.value === props.value)
      : props.type === 'travel-agent'
        ? travelagents.find(opt => opt.value === props.value)
        : null;

  return (
    <Select
      options={props.type === 'airport' ? airports : props.type === 'travel-agent' ? travelagents : airlines}
      value={currentValue}
      onChange={handleChange}
    />
  );

}

export default AirportSearch;
